import React, { Component } from 'react';
import { getCurrentResource } from '../../util/tools';
import PlainFullDescription from '../../components/fulldescription/PlainFullDescription';
import styles from '../../components/fulldescription/FullDescription.module.css';
import { FORM_ORGANIZATION_FT } from '../../util/consts/forms';
import { CLASS_ORGANIZATION } from '../../util/consts/classes';

class OrganizationPage extends Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.plain.Organization;
		this.plainInfo = {
			app: props.app,
			page: this,
			class: CLASS_ORGANIZATION,
			instanceModelId: FORM_ORGANIZATION_FT,
			instanceId: this.props.match.params.id,
			param: {}
		};
	}

	render() {
		return (
			<React.Fragment>
				<div className={styles.divPlainTitle}>
					{this.resource.title}
				</div>
				<PlainFullDescription plain={this.plainInfo} />
			</React.Fragment>
		)
	}
}

export default OrganizationPage;
